import { useState, useEffect } from 'react';

// Landing page only. Every other screen in this app is fluid/JS-free
// (clamp(), vw, maxWidth) — this hook exists because the landing page's
// Features section is a genuinely different layout on mobile vs desktop,
// not just a scaled one, so CSS alone can't express the split.
//
// Breakpoint is 1023px, not the usual ~767px "phone" cutoff. The desktop
// Features grid is two 644px-wide cards (+ gap + page padding) — its native
// design width is ~1440px. Below that, the grid's `1fr` columns compress
// the cards smaller than 644px, but the overlay mockups inside them
// (ProtocolMockCards, HealthProfileCard, SignalGrid, WeightInterpretationCard)
// are sized in fixed px for a 644px-wide card, so a compressed "medium"-width
// window made them overflow worse, not better. Switching to the mobile
// (full-bleed, stacked) layout at any width below the grid's comfortable
// range avoids that entirely, rather than trying to make the grid compress
// gracefully.
const QUERY = '(max-width: 1023px)';
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};
